/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Calendar, Clock } from 'lucide-react';

export const AnnouncementBar = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [nextSeminar, setNextSeminar] = useState(null);

  // Calculate next Saturday at 11 AM IST
  const getNextSaturday = () => {
    const now = new Date();
    
    // Convert to IST
    const istOffset = 5.5 * 60 * 60 * 1000; // IST is UTC+5:30
    const istNow = new Date(now.getTime() + istOffset);
    
    const currentDay = istNow.getUTCDay();
    const daysUntilSaturday = (6 - currentDay + 7) % 7 || 7;
    
    const nextSat = new Date(istNow);
    nextSat.setUTCDate(istNow.getUTCDate() + daysUntilSaturday);
    nextSat.setUTCHours(11, 0, 0, 0); // 11:00 AM IST
    
    return nextSat;
  };

  useEffect(() => {
    const next = getNextSaturday();
    setNextSeminar(next);
  }, []);

  useEffect(() => {
    if (!nextSeminar) return;

    const timer = setInterval(() => {
      const now = new Date();
      const istOffset = 5.5 * 60 * 60 * 1000;
      const istNow = new Date(now.getTime() + istOffset);
      
      const distance = nextSeminar.getTime() - istNow.getTime();

      if (distance < 0) {
        const next = getNextSaturday();
        setNextSeminar(next);
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(timer);
  }, [nextSeminar]);


  const scrollToSeminar = () => {
    const element = document.getElementById('seminar');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-gradient-to-r from-orange-600 via-pink-600 to-purple-600 text-white py-2.5 px-3 sticky top-0 z-[9999] shadow-lg">
      <div className="container mx-auto">
        {/* Desktop Layout */}
        <div className="hidden md:flex items-center justify-between gap-4 text-sm">
          <div className="flex items-center gap-3">
            <Calendar className="h-4 w-4" />
            <span className="font-semibold">Ultimate Video/Film Editing Seminar. This Saturday 11 AM IST</span>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4" />
              <div className="flex gap-1 font-mono">
                <span>{String(timeLeft.days).padStart(2, '0')}d</span>
                <span>:</span>
                <span>{String(timeLeft.hours).padStart(2, '0')}h</span>
                <span>:</span>
                <span>{String(timeLeft.minutes).padStart(2, '0')}m</span>
                <span>:</span>
                <span>{String(timeLeft.seconds).padStart(2, '0')}s</span>
              </div>
            </div>
            <button 
              onClick={scrollToSeminar}
              className="bg-white text-purple-600 px-4 py-1.5 rounded-full font-semibold hover:bg-purple-50 transition-colors text-xs whitespace-nowrap"
            >
              Register Now
            </button>
          </div>
        </div>

        {/* Mobile Layout - Two lines for better readability */}
        <div className="md:hidden space-y-1.5">
          <div className="flex items-center justify-between text-xs">
            <div className="flex items-center gap-1.5">
              <Calendar className="h-3.5 w-3.5 flex-shrink-0" />
              <span className="font-semibold">Ultimate Video/Film Editing Seminar. This Saturday 11 AM IST</span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <Clock className="h-3.5 w-3.5" />
              <div className="flex gap-0.5 font-mono text-[11px] leading-none tabular-nums">
                <span>{String(timeLeft.days).padStart(2, '0')}d</span>
                <span>:</span>
                <span>{String(timeLeft.hours).padStart(2, '0')}h</span>
                <span>:</span>
                <span>{String(timeLeft.minutes).padStart(2, '0')}m</span>
                <span>:</span>
                <span>{String(timeLeft.seconds).padStart(2, '0')}s</span>
              </div>
            </div>
            <button 
              onClick={scrollToSeminar}
              className="bg-white text-purple-600 px-3 py-1 rounded-full font-semibold hover:bg-purple-50 transition-colors text-[11px] whitespace-nowrap leading-tight"
            >
              Register Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
